import api from '../../services/api';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const getStudentHistoryClasses = createAsyncThunk(
  'getStudentHistoryClasses/fetchAll',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/migration/${id}`,
        method: 'GET',
      });
      return { data: response?.data, status: response?.status };
    } catch (error) {
      console.log(error);
      return rejectWithValue({
        status: error.response.status,
        data: error.response.data,
      });
    }
  },
);
export const getClassesList = createAsyncThunk(
  'getClassesList/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/migration/classes`,
        method: 'GET',
      });
      return { data: response?.data, status: response?.status };
    } catch (error) {
      console.log(error);
      return rejectWithValue({
        status: error.response.status,
        data: error.response.data,
      });
    }
  },
);

export const getMigrationsList = createAsyncThunk(
  'getMigrationsList/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/migration/`,
        method: 'GET',
      });
      return { data: response?.data, status: response?.status };
    } catch (error) {
      console.log(error);
      return rejectWithValue({
        status: error.response.status,
        data: error.response.data,
      });
    }
  },
);
export const postNewClasses = createAsyncThunk(
  'postNewClasses/post',
  async (Code, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/migration/${Code}`,
        method: 'POST',
      });
      return { data: response?.data, status: response?.status };
    } catch (error) {
      console.log(error);
      return rejectWithValue({
        status: error.response.status,
        data: error.response.data,
      });
    }
  },
);
export const getAcademicYearsList = createAsyncThunk(
  'getAcademicYears/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/academicyear/`,
        method: 'GET',
      });
      return { data: response?.data, status: response?.status };
    } catch (error) {
      console.log(error);
      return rejectWithValue({
        status: error.response.status,
        data: error.response.data,
      });
    }
  },
);
export const postAcademicYearsList = createAsyncThunk(
  'postAcademicYears/post',
  async (newData, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/academicyear/`,
        method: 'POST',
        data: newData,
      });
      return { data: response?.data, status: response?.status };
    } catch (error) {
      return rejectWithValue({
        status: error.response.status,
        data: error.response.data,
      });
    }
  },
);
export const editAcademicYearsList = createAsyncThunk(
  'editAcademicYears/put',
  async (editData, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/academicyear/`,
        method: 'PUT',
        data: editData,
      });
      return { data: response?.data, status: response?.status };
    } catch (error) {
      console.log(error);
      return rejectWithValue({
        status: error.response.status,
        data: error.response.data,
      });
    }
  },
);
export const getStudentPastMarksPayments = createAsyncThunk(
  'getStudentPastMarksPayments/get',
  async (obj, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/migration/student?studentId=${obj.studentId}&academicCode=${obj.academicCode}`,
        method: 'GET',
      });
      return { data: response?.data, status: response?.status };
    } catch (error) {
      console.log(error);
      return rejectWithValue({
        status: error.response.status,
        data: error.response.data,
      });
    }
  },
);
const HistorySlice = createSlice({
  name: 'history',
  initialState: {},
  reducers: {},
});
export default HistorySlice.reducer;
